export default __webpack_public_path__ + "static/media/263694.f01a8ceb.png";